class CartUpsellSlider extends HTMLElement {
  constructor() {
    super();
    this.sliderInitialized = false;
  }

  connectedCallback() {
    this.initWhenReady();
    this.initAddToCartButtons();
  }

  initWhenReady() {
    if (typeof Splide !== "undefined") {
      this.initSlider();
      return;
    }
    // Splide not loaded yet — wait briefly for it
    let tries = 0;
    const timer = setInterval(() => {
      if (typeof Splide !== "undefined") {
        clearInterval(timer);
        this.initSlider();
      }
      if (++tries > 25) clearInterval(timer);
    }, 200);
  }

  initSlider() {
    if (this.sliderInitialized) return;

    const splideEl = this.querySelector(".splide");
    if (!splideEl) return;

    this.splide = new Splide(splideEl, {
      perPage: 1,
      perMove: 1,
      gap: "16px",
      speed: 400,
      arrows: true,      // uses the custom arrows inside .splide__arrows
      pagination: false,
      drag: true,
    }).mount();

    this.sliderInitialized = true;
  }

  initAddToCartButtons() {
    this.querySelectorAll(".upsell-add-to-cart").forEach((button) => {
      button.addEventListener("click", () => {
        const variantId = button.dataset.variantId;
        if (!variantId) return;

        button.disabled = true;
        const originalText = button.textContent;
        button.textContent = "Adding...";

        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        })
          .then((res) => {
            if (!res.ok) throw new Error("Failed to add to cart");
            return res.json();
          })
          .then(() => {
            return fetch("/?sections=cart-drawer,cart-icon-bubble");
          })
          .then((res) => {
            if (!res.ok) throw new Error("Failed to fetch updated cart sections");
            return res.json();
          })
          .then((data) => {
            const cartDrawer = document.querySelector("m-cart-drawer");
            if (cartDrawer) {
              cartDrawer.renderContents({
                sections: {
                  "cart-drawer": data["cart-drawer"],
                  "cart-icon-bubble": data["cart-icon-bubble"],
                },
              });
            }
            // Optionally re-init upsell slider if needed
            window.initCartUpsellSlider?.();
          })
          .catch((error) => {
            console.error(error);
            alert("Sorry, there was a problem adding the item to your cart.");
          })
          .finally(() => {
            button.disabled = false;
            button.textContent = originalText;
          });
      });
    });
  }
}

customElements.define("cart-upsell-slider", CartUpsellSlider);
